import { A11yText, IconMoon } from "./TextFormat";
import { useEffect, useRef, useState } from "react"
import SimpleBar from "simplebar-react";
import { Helmet } from "react-helmet";
const sellerInfo={
  sellerName:"Nvisions",
  FROM:"Jongro-gu, Seoul, South Korea"
};
const ContentBook = ({
  defaultPageIndex,
  showIndex
}) => {
  const [currentPage,setCurrentPage] = useState(defaultPageIndex);
  const titles = [
    'VoiceOver Focus Issue - Intro',
    'VoiceOver Focus Issue - Ugly navigating',
    'VoiceOver Focus Issue - Pretty navigating'
  ];

  const ContentList = [
    //page1
    ()=>{
      return (
        <div class="text wide-margin" style={{textAlign:"center"}}>
          <h2 style={{
            margin:"5% 0"
          }}>
          <div role="text">
            Hey! iOS VoiceOver!
          </div>
          <div role="text">
            please stop cutting the navigating focus of the inline text!
          </div>
          </h2>
          <p>
            Dividing a text excessively is not good for other screen readers, too. but, I think maybe you guys know why web designers had been dividing the texts until now. 
          </p>
          <p>
            Text styling makes web and app visual designers divide the VoiceOver focus regardless of their intention, unfortunately.
          </p>
          <p>
            They cannot be given up text styling.
          </p>
          <p>
            This is a dilemma of web styling and accessibility.
          </p>
          <p>
            but, now we must fix it for the acquiring information comfortable of everyone.
          </p>
        </div>
      )
    },
    //page2
    ()=>{
      const uglyList=[
        {
          productName:"D.I.D Smart Scissors Green",
          price:8.99,
          price_discounted:5.99,
          thumb:<IconMoon
          IconClassName="icon-scissors green" />
        },
        {
          productName:"D.I.D Smart Scissors Black",
          price:8.99,
          price_discounted:3.99,
          thumb:<IconMoon
          IconClassName="icon-scissors black" />,
        },
        {
          productName:"D.I.D Smart Scissors Premium White",
          price:12.99,
          price_discounted:6.495  ,
          thumb:<IconMoon
          IconClassName="icon-scissors Premium white" />
        },
        {
          productName:"D.I.D Smart Scissors Premium Black",
          price:12.99,
          price_discounted:6.495  ,
          thumb:<IconMoon
          IconClassName="icon-scissors Premium black" />
        },
        {
          productName:"D.I.D Smart Scissors Premium Aurora Special Edition",
          price:18.99,
          price_discounted:12.99,
          thumb:<IconMoon
          IconClassName="icon-scissors Premium aurora" />
        }
      ]
      return (
        <>
          <h2>Ugly navigating</h2>
          <p>
            Please navigate the below list items.
          </p>
          <ul className="example-product_list">
            <ShoppingList stickyFocus={false} List={uglyList} />
          </ul>
        </>
      )
    },
    ()=>{
      const PrettyList=[
        {
          productName:"D.I.D Smart Scissors Green",
          price:8.99,
          price_discounted:5.99,
          thumb:<IconMoon
          IconClassName="icon-scissors green" />
        },
        {
          productName:"D.I.D Smart Scissors Black",
          price:8.99,
          price_discounted:3.99,
          thumb:<IconMoon
          IconClassName="icon-scissors black" />
        },
        {
          productName:"D.I.D Smart Scissors Premium White",
          price:12.99,
          price_discounted:6.495  ,
          thumb:<IconMoon
          IconClassName="icon-scissors Premium white" />
        },
        {
          productName:"D.I.D Smart Scissors Premium Black",
          price:12.99,
          price_discounted:6.495  ,
          thumb:<IconMoon
          IconClassName="icon-scissors Premium black" />
        },
        {
          productName:"D.I.D Smart Scissors Premium Aurora Special Edition",
          price:18.99,
          price_discounted:12.99,
          thumb:<IconMoon
          IconClassName="icon-scissors Premium aurora" />
        }
      ]
      return (
        <>
          <h2>Pretty navigating</h2>
          <p>The item links of this list can be swipe right or left once to navigate and hear the item text more quickly than a list of the previous page.</p>
          <ul className="example-product_list">
            <ShoppingList stickyFocus={true} List={PrettyList} />
          </ul>
        </>
      )
    },
  ];
  const PreviousContentAvailable = ContentList[currentPage-1] ? true : false;
  const NextContentAvailable = ContentList[currentPage+1] ? true : false;
  let ContentViewRef = useRef();
  let ControllerFocusRef = useRef();
  
  const setPage = (idx) => {
    if(ContentList[idx]){
      setCurrentPage(idx);
      setTimeout(()=>{
        ContentViewRef.current.scrollIntoView();
      },150);
    }
  }

  function setPageButtonClickListener(e){
    const target = e.target;
    const ID = target.id;
    switch(ID){
      case "page-next":
        setPage(currentPage+1);
        break;
      case "page-prev":
        setPage(currentPage-1);
        break;
      }
      setTimeout(()=>{
        if(ControllerFocusRef.current){
          ControllerFocusRef.current.focus();
        }
      },150)
  }

  const getPageText = () => {
    return (
      <span id="current-page-index" role="text">
        {`Current Page: ${currentPage+1} of ${ContentList.length}`}
      </span>
    )
  }

  useEffect(()=>{
    const isMobile = window.matchMedia('screen and (max-width:1024px)');
    isMobile.addEventListener('change',function(){
      setTimeout(()=>{
        ContentViewRef.current.scrollIntoView();
      },100)
    })
  },[ContentViewRef])

  return ( 
  <> 
    <Helmet>
      <title>{titles[currentPage]}</title>
    </Helmet>
    <header>
      <h1>EXAMPLE-PAGE</h1>
    </header>

      <main>
        <div className="page-list-wrapper">
            <div className="controllers" role="navigation" role="pagination">
              <button 
              aria-describedby="current-page-index hint-prev"
              ref={!NextContentAvailable ? ControllerFocusRef : null}
              disabled={!PreviousContentAvailable} id="page-prev" onClick={setPageButtonClickListener}>Previous</button>
              <button aria-describedby="current-page-index hint-next"
              ref={!PreviousContentAvailable ? ControllerFocusRef : null}
              disabled={!NextContentAvailable} id="page-next" onClick={setPageButtonClickListener}>Next</button>
              <div
              className={`current-page view-${showIndex}`}
              aria-live="polite">
                <span aria-hidden="true">
                  {`Page: ${currentPage+1}/${ContentList.length}`}
                </span>
                <A11yText>{getPageText()}</A11yText>
                <span className="sr-hint" id="hint-prev">
                  , double-tap to flip to the previous page
                </span>
                <span className="sr-hint" id="hint-next">
                  , double-tap to flip to the next page
                </span>
                
              </div>
            </div>
            <div className="page-list">      
                  {
                    ContentList.map((el,idx)=>{
                      return (
                        <SimpleBar>
                          <div
                            key={idx} className={
                              "page-items"+(idx === currentPage ? " active" : "")
                            }
                            ref={currentPage === idx ? ContentViewRef : null}>                  
                              {el()}
                          </div>
                        </SimpleBar>
                      )
                    })
                  }
            </div>
        </div>
      </main>
  </>
  )
}

const ShoppingList = ({List,stickyFocus})=>{
    return (
      <>
        {List.map((el,idx)=>{
            return <li key={"prNum_"+idx}>
              <a href="#" className="as-normal block-link">
                <div className="container product-card"
                role={stickyFocus ? "text" : undefined}>
                  <div role={stickyFocus ? "text" : undefined}
                   className="socket product_thumb"
                   role={stickyFocus ? "text" : undefined}>
                    {el.thumb ? el.thumb :
                    <IconMoon /> }
                  </div>
                  <div className="socket product_info"
                  role={stickyFocus ? "text" : undefined}>
                    <strong
                     role={stickyFocus ? "text" : undefined}
                     className="product_name">{el.productName}</strong>
                  </div>
                  <div className="socket seller_info" role={stickyFocus ? "text" : undefined}>
                    <strong className="seller_title">
                    <div className="seller_logo">
                      <A11yText>Logo</A11yText>
                    </div>
                    <A11yText>Seller:</A11yText>
                      {sellerInfo.sellerName}
                    </strong>
                  </div>
                  <div className="socket price_info"
                  role={stickyFocus ? "text" : undefined}>
                    {el.price_discounted ? 
                      <>
                      <big 
                      role={stickyFocus ? "text" : undefined}
                      className="discounted_percent">
                        <A11yText>Discount</A11yText>
                        {((el.price-el.price_discounted)/el.price*100).toFixed(1)+"%"}
                      </big>&nbsp;
                      <big 
                      role={stickyFocus ? "text" : undefined}
                      className="price_discounted">
                        <A11yText>Current:</A11yText>
                        {el.price_discounted+"$"}
                      </big>&nbsp;
                      </>
                    : false}
                    <del 
                    role={stickyFocus ? "text" : undefined}
                    className="price_regular">
                      <A11yText>Regular:</A11yText>
                      {el.price+"$"}
                    </del>
                  </div>
                  <div className="socket delivery_info"
                  role={stickyFocus ? "text" : undefined}>
                    <p role={stickyFocus ? "text" : undefined}><IconMoon IconClassName={"icon-flight_takeoff"} IconAltText="Shipping Start"></IconMoon> April. 21. 2021 <span style={{fontSize:"0.8em"}}><A11yText>Delivery From</A11yText>Seoul, South Korea</span></p>
                    <p role={stickyFocus ? "text" : undefined}>
                      <IconMoon IconClassName={"icon-gift"} IconAltText="Arriving at"></IconMoon> 7:00PM. April. 29. 2021
                    </p>
                  </div>
                </div>
              </a>
            </li>
          })
        }
    </>
  )
}

ShoppingList.defaultProps = {
  stickyFocus:false
}

ContentBook.defaultProps = {
  defaultPageIndex:0,
  showIndex:true
}
export default ContentBook;